export const AVAILABILITY_TYPES = {
  ALL_YEAR: "all_year",
  SEASONAL: "seasonal"
}
